module.exports = __webpack_public_path__ + "img/logo-label.5c2c74f9.png";